import { createSlice } from "@reduxjs/toolkit";
import {
  FETCH_SCENARIOS_START,
  FETCH_SCENARIOS_SUCCESS,
  FETCH_SCENARIOS_FAILURE,
} from "state/types/actionTypes";

const initialState = {
  scenarios: [],
  loading: false,
  error: null,
};

const scenariosSlice = createSlice({
  name: "scenarios",
  initialState,
  reducers: {
    clearScenarios: (state) => {
      state.scenarios = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_SCENARIOS_START, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FETCH_SCENARIOS_SUCCESS, (state, action) => {
        state.scenarios = action.payload;
        state.loading = false;
      })
      .addCase(FETCH_SCENARIOS_FAILURE, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const scenariosReducer = scenariosSlice.reducer;
export const { clearScenarios } = scenariosSlice.actions;
